import React from 'react'
import { fadeIn } from '../../../Functions/GlobalAnimations'
import { Col, Container, Row } from 'react-bootstrap'
import { m } from "framer-motion"
import { opportunitiesData } from './OpportunitiesData';
import { ParagraphComp } from '../../ParagraphComp/ParagraphComp';
import Services3 from '../../Services/Services3';

const Opportunities = () => {
    return (
        <>
            <m.section className="bg-[#f7f7f7] max-sm:py-[70px] py-[70px] lg:py-[70px] md:py-[70px] sm:py-[70px] xs:py-[50px]" {...fadeIn}>
                <Container>
                    <Row className="justify-center">
                        <Col md={12} className="text-center mb-[3%]">
                            <h6 className="text-black font-extrabold max-sm:text-3xl text-4xl">Opportunities to make a difference, Now!</h6>
                            <ParagraphComp className='max-sm:text-lg text-black lg:w-[85%] m-auto' text='Reach out directly to changemakers! You can login to submit your offers, asks and events!*' />
                        </Col>
                        
                    </Row>
                    <Services3 grid="row-cols-1 row-cols-lg-4 row-cols-md-2 gap-y-10 justify-center" theme='service-style-02' className="" data={opportunitiesData} animation={fadeIn} />
                </Container>
            </m.section>
        </>
    )
}

export default Opportunities